
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"isolation":"isolate"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"isolation:isolate","viewBox":"792 287 64 32","width":"64pt","height":"32pt"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M796 287h56c2.208 0 4 1.792 4 4v24c0 2.208-1.792 4-4 4h-56c-2.208 0-4-1.792-4-4v-24c0-2.208 1.792-4 4-4z","fill":"#f5c518"}}),_c('path',{attrs:{"d":"M800 312h5v-18h-5v18zm15.673-18l-1.12 8.408-.695-4.573a124.858 124.858 0 00-.58-3.835H807v18h4.242l.016-11.886L813.044 312h3.019l1.695-12.148.013 12.148H822v-18h-6.327zM824 312v-18h7.805a3.185 3.185 0 013.195 3.177v11.646a3.184 3.184 0 01-3.195 3.177H824zm5.832-14.76c-.198-.108-.577-.159-1.129-.159v11.81c.728 0 1.177-.131 1.345-.404.168-.27.254-1.001.254-2.2v-6.979c0-.814-.03-1.334-.086-1.564a.733.733 0 00-.384-.504zm14.598 1.267h.32c1.795 0 3.25 1.406 3.25 3.138v7.217c0 1.733-1.455 3.138-3.25 3.138h-.32a3.28 3.28 0 01-2.658-1.332l-.288 1.101H837V294h4.784v5.781a3.386 3.386 0 012.646-1.274zm-1.024 8.777v-4.265c0-.705-.046-1.167-.14-1.38-.094-.213-.47-.35-.734-.35s-.671.111-.75.299v7.219c.09.206.478.32.75.32.271 0 .666-.11.749-.32.083-.209.125-.719.125-1.523z"}})])
          )
        }
      }
    